import React, { useState } from 'react';
import { SpinnerContext } from './spinner';
import './spinner.scss';

export const SpinnerProvider = ({ children }: { children: React.ReactNode }) => {
  const [visible, setVisible] = useState(false);

  return (
    <SpinnerContext.Provider
      value={{
        showSpinner: () => setVisible(true),
        hideSpinner: () => setVisible(false),
      }}
    >
      {children}
      {visible && (
        <div className="spinner-overlay">
          <div className="spinner" />
        </div>
      )}
    </SpinnerContext.Provider>
  );
};
